import type { FaireProductEntity } from "../../entity_types/product";

export const p_4jjawhs24y: FaireProductEntity = {
  token: "p_4jjawhs24y",
  type: "product",
  name: "Birthday Cake Bath Treats (3 pc bath bomb set)",
  brandToken: "b_arfo4zvzts",
  brandName: "NCLA Beauty",
  imageUrl:
    "https://cdn.faire.com/fastly/5f57342ec5833e3da527e076be9430e927d95132980ce6497afe7ba32c2eae56.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/72ffa69b05b3cbfd76af9522b9b824d0f7c678e33ddb90dda4fc3139aad8ace3.jpeg",
    "https://cdn.faire.com/fastly/8aa452ab967974822877f920841cf8034a481b2e3c20458c8873a8cff700bffe.jpeg",
    "https://cdn.faire.com/fastly/ce0d84343db5283a585b6ce3fc9dec1516ce9a567ea85ab3a299b307acd52f4b.jpeg",
    "https://cdn.faire.com/fastly/2a7acdef2464fd475987afc5932123290a4504d1e4f0f5012e0d5e533544333c.jpeg",
    "https://cdn.faire.com/fastly/f943db587df9d2bce1a6ada4fbad863456ac81512f9aaac5eaec7a6127212d51.jpeg",
    "https://cdn.faire.com/fastly/288aec343afc15ff24be4c8a6b2d8930e557a82ac89bd3cfa78cbfe4291756d2.jpeg",
  ],
  priceDollars: 9,
  description:
    "An ultra sweet trio of donut-shaped bath bombs in a delicious birthday cake scent. This hand made bath bomb trio will leave skin ultra soft and smelling delicious! Sit back, fizz, and relax!\n\nEach set comes with 3 donut shaped bath treats made with nourishing, skin-soothing, and hydrating ingredients like epsom salt, kaolin clay, and shea butter. It's also infused with an essential oil blend to bring an aromatherapeutic experience to your bath time.\n\n𝐈𝐧𝐠𝐫𝐞𝐝𝐢𝐞𝐧𝐭𝐬:\nSodium Bicarbonate, Citric Acid, Organic Shea Butter, White Kaolin Clay, Essential Oil Blend, Polysorbate 80, Isopropyl Alcohol, Epsom Salt, Mica-Colorant",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:06.125Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
